export default __webpack_public_path__ + "static/media/investors.3d8d2d09.mp3";